(() => {
  angular
    .module('adtDirectives')
    .directive('datepicker', () => {
      return {
        restrict: 'A',
        scope: {
          startDate: '=',
          endDate: '=',
          minDate: '=',
          maxDate: '=',
          hideClear: '=',
        },
        link: (scope, element) => {
          const today = new Date();
          const hideClear = scope.hideClear ? 'hide-clear' : '';

          element.daterangepicker({
            locale: {
              firstDay: 1
            },
            showWeekNumbers: true,
            weekRanges: true,
            dateLimit: {
              months: 3
            },
            minDate: scope.minDate,
            maxDate: scope.maxDate,
            startDate: scope.startDate ? scope.startDate : today,
            endDate: scope.endDate ? scope.endDate : today,
            opens: 'left',
            format: 'yyyy-MM-dd',
            applyClass: 'btn btn-primary',
            clearClass: `btn btn-neutral ${hideClear}`,
          }, (start, end) => {
            scope.startDate = start ? start.toString('yyyy-MM-dd') : null;
            scope.endDate = end ? end.toString('yyyy-MM-dd') : null;
            scope.$apply();
          });
        }
      }
  });
})();
